import { render, staticRenderFns } from "./LogotipoBrasao.vue?vue&type=template&id=8f719b80"
import script from "./LogotipoBrasao.vue?vue&type=script&lang=js"
export * from "./LogotipoBrasao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports